/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import styled from "styled-components/macro";
import Button from "components/CustomButton/CustomButton.jsx";
import { useAuth } from "../../context/AuthContext";

const ErrorWrapper = styled.div`
  color: red;
`;

const LoginPage = () => {
  const [cardHidden, setCardHidden] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [captchaResponse, setCaptchaResponse] = useState("");
  const { login } = useAuth();
  const isMounted = React.useRef(true);
  const isLocal = window.location.hostname === "localhost";

  useEffect(() => {
    isMounted.current = true;
    const timer = setTimeout(() => {
      if (isMounted.current) setCardHidden(false);
    }, 700);

    if (isLocal) {
      setCaptchaResponse("fake-token");
    } else {
      try {
        if (window.mtcaptcha) {
          window.mtcaptcha.remove();
          window.mtcaptcha.renderUI();
        }
      } catch (err) {
        console.error(err);
      }
      window.mt_verifiedcb = (state) => {
        setCaptchaResponse(state.verifiedToken);
      };
    }

    return () => {
      isMounted.current = false;
      clearTimeout(timer);
    };
  }, [isLocal]);

  const reloadCaptcha = () => {
    setCaptchaResponse("");
    if (!isLocal) {
      try {
        if (window.mtcaptcha) {
          window.mtcaptcha.remove();
          window.mtcaptcha.renderUI();
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleLogin = async () => {
    const defaultErrorMessage =
      "An error occured during the attempt to login. Please try again.";
    if (isMounted.current) setError("");
    
    if (!isLocal && !captchaResponse) {
      return;
    }

    try {
      const res = await login(email, password, captchaResponse);
      if (isMounted.current && res && Object.hasOwn(res, "error")) {
        setError(defaultErrorMessage);
        reloadCaptcha();
      }
    } catch (e) {
      if (isMounted.current) setError(defaultErrorMessage);
      reloadCaptcha();
    }
  };

  return (
    <Grid>
      <Row>
        <Col md={4} sm={6} mdOffset={4} smOffset={3}>
          <form>
            <Card
              hidden={cardHidden}
              textCenter
              title="Login"
              content={
                <div>
                  <FormGroup>
                    <ControlLabel>Email</ControlLabel>
                    <FormControl
                      placeholder="Enter email"
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Password</ControlLabel>
                    <FormControl
                      placeholder="Password"
                      type="password"
                      autoComplete="off"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </FormGroup>
                  {!isLocal && <div className="mtcaptcha"></div>}
                </div>
              }
              legend={
                <Button bsStyle="info" fill wd onClick={handleLogin} disabled={!email || !password || (!isLocal && !captchaResponse)}>
                  Login
                </Button>
              }
              ftTextCenter
            />
            <ErrorWrapper>{error}</ErrorWrapper>
          </form>
        </Col>
      </Row>
    </Grid>
  );
};

export default LoginPage;
